module.exports = __webpack_public_path__ + "img/background-55.438cb0b4.png";